<template>
    <b-modal id="dictionaryDetailModal01" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">{{title}} 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{dictionaryData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>질환구분</th>
                                <td><span>{{dictionaryData.insurance_category_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>처방유형</th>
                                <td><span>{{dictionaryData.insurance_type_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{dictionaryData.prescribe_medicine}}</span></td>
                            </tr>
                            <tr>
                                <th>처방 설명</th>
                                <td><span>{{dictionaryData.insurance_dictionary_note1}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'dictionaryDetailModal01',
        props: {
            title: String,
            dictionaryData : {
                dictionary_nm : '',
                insurance_category_nm : '',
                insurance_type_nm : '',
                prescribe_medicine : '',
                item : {}
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.dictionaryData.item);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>